import { z } from 'zod'

export const postFormSchema = z.object({
  title: z.string().min(1, 'Título é obrigatório'),
  content: z.string().min(1, 'Conteúdo é obrigatório'),
  type: z.enum(['COMMUNITY', 'CREATOR', 'FORMAT', 'TREND', 'AESTHETIC', 'SUBJECT'], {
    required_error: 'Tipo é obrigatório',
  }),
  url: z.string().url('URL inválida').min(1, 'URL é obrigatória'),
  trends: z.array(z.string()).optional(),
  territories: z.array(z.string()).optional(),
  contexts: z.array(z.string()).optional(),
  topics: z.array(z.string()).optional(),
})

export type PostFormData = z.infer<typeof postFormSchema>

export interface CreatePostModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onSuccess?: () => void
}
